import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalGiaHanNgayTra } from "./ModalGiaHanNgayTra";

export const BtnGiaHanNgayTra = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a className="dropdown-item" onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Gia hạn ngày trả"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-gia-han.png" />
        </PopoversBootrap>
        <span class="vertical-align-v2">Gia hạn trả lãi</span>
      </a>
      {show && (
        <ModalGiaHanNgayTra
          show={show}
          onHide={handleClose}
          NhanVayId={item.ID}
        />
      )}
    </>
  );
};
